module.exports = __webpack_public_path__ + "static/media/savings.687a4506.png";